import { Box, Button, Card, CardContent, Divider, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Ras_Pros from "../../public/main/rasMap.png"
import Ras_Pros_Mobile from "../../public/main/rasMapMobile.png"
import { useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';
import { WhyWe } from './WhyWe/WhyWe';
import { Helmet } from 'react-helmet';
import { PaymentMethods } from './PaymentMethods/PaymentMethods';
import { motion } from "framer-motion";
import ForBusiness from './ForBusiness/ForBusiness';
import { ComparisonHome } from './ComparisonHome/ComparisonHome';
import CoinComponent from './RascoinSec/RascoinSec';
import LatestBlogs from '../Blog/LatestBlogs';
import RobotImage from "../../public/main/Profession.png";
import rightImage from "../../public/main/leftImage.png"
import leftImage from "../../public/main/Rastcom.ca-rightImage4.png"
import { Link } from "react-router-dom";
import Elo from "./video/Elo";
import Ai from './Ai/Ai';
import CommercialInsuranceFeature from "./Inssurance/Inssurance";
import { SeamlessTools } from "./SeamlessTools/SeamlessTools";

const MotionImage = motion.img;
const MotionTypography = motion(Typography);
// Framer Motion Variants
const containerVariants = {
    hidden: { opacity: 0, scale: 0.98 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.6,
            ease: [0.25, 0.8, 0.25, 1],
            when: "beforeChildren",
            staggerChildren: 0.2,
        },
    },
};

const childFadeSlideUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.25, 0.8, 0.25, 1] } },
};

export const Home = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('main.tags.homeTitle')}</title>
                <meta name="description" content={t('main.tags.homeDescription')} />
            </Helmet>
            <Box
                sx={{
                    backgroundColor: "#112240",
                }}
            >
                <Grid container
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: "#112240",
                        flexDirection: { xs: 'row', md: 'row-reverse' },
                    }}
                >
                    <Grid
                        item
                        xs={11}
                        md={5}
                        lg={5}
                        sx={{
                            position: "relative",
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            height: { xs: '350px', sm: "700px", md: 'auto' },
                            minHeight: { md: '500px' },
                            borderRadius: "5px",
                            overflow: "hidden",
                            margin: "0px 15px",
                            paddingTop: '30px',
                        }}
                    >

                        <MotionImage
                            src={Ras_Pros}
                            alt='raspros'
                            initial={{ opacity: 0, x: 100, scale: 0.95 }}
                            animate={{ opacity: 1, x: 0, scale: 1 }}
                            transition={{ duration: 1.1, ease: "easeOut" }}
                            style={{
                                position: 'absolute',
                                border: "5px solid white",
                                right: '-70%',
                                width: '150%',
                                height: 'auto',
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                                padding: '10px',
                                borderRadius: '10px'
                            }}
                        />


                        <MotionImage
                            src={Ras_Pros_Mobile}
                            alt='raspros mobile'
                            initial={{ opacity: 0, scale: 0.9, y: 50 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 1.1, ease: "easeOut" }}
                            style={{
                                position: "absolute",
                                top: '18%',
                                left: 0,
                                transform: "translate(2%, 50%)", // ✅ here we do it safely
                                width: '37%',
                                height: 'auto',
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                                padding: '10px',
                                marginLeft: 5,
                                borderRadius: '10px',
                                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            }}
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        sm={12}
                        xs={12}
                        mb={3}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignContent: "center",
                            padding: "15px",
                            minHeight: "400px",
                            marginY: { xs: 3, md: 6 },
                        }}
                    >
                        <motion.div
                            variants={containerVariants}
                            initial="hidden"
                            animate="visible"
                        >
                            <Card
                                sx={{
                                    maxWidth: { xs: '100vw', md: '50vw' },
                                    marginX: '10px',
                                    background: "#112240",
                                    boxShadow: 'none',
                                    borderRadius: '20px',
                                    overflow: "hidden"
                                }}
                            >
                                <CardContent>
                                    <motion.div variants={childFadeSlideUp}>
                                        <Box
                                            sx={{
                                                borderTop: '4px solid  #7223b5',
                                                borderRadius: '10px 10px 0 0',
                                                paddingTop: '10px',
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: { xs: 28, sm: 42 },
                                                    fontWeight: 600,
                                                    color: "#F9FAFB",
                                                    marginBottom: '10px',
                                                    paddingX: '20px',
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {t('main.banner.titleFirst')}
                                            </Typography>
                                        </Box>
                                    </motion.div>

                                    <motion.div variants={childFadeSlideUp}>
                                        <Typography
                                            sx={{
                                                fontSize: 18,
                                                color: "#F9FAFB",
                                                paddingX: '20px',
                                                marginBottom: '20px'
                                            }}
                                        >
                                            {t('main.banner.descriptionFirst')}
                                        </Typography>
                                    </motion.div>
                                </CardContent>
                            </Card>

                            <motion.div variants={childFadeSlideUp}>
                                <Link to={`/${i18n.language}/signup`}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            background: 'linear-gradient(135deg, #3b0764, #9333ea)', // 🌌 deep purple gradient
                                            color: '#FFFFFF',
                                            border: 'none',
                                            borderRadius: '10px',
                                            maxWidth: { xs: '100vw', md: '50vw' },
                                            width: '100%',
                                            margin: '10px auto',
                                            paddingX: '20px',
                                            // paddingY: '12px',
                                            fontSize: '1rem',
                                            textTransform: 'capitalize',
                                            boxShadow: '0 0 16px rgba(147, 51, 234, 0.4)', // ✨ purple glow
                                            transition: 'all 0.3s ease',

                                            '&:hover': {
                                                background: 'linear-gradient(135deg, #581c87, #a855f7)',
                                                boxShadow: '0 0 22px rgba(147, 51, 234, 0.6)',
                                            },
                                        }}
                                    >
                                        {t('main.banner.signUp')}
                                    </Button>

                                </Link>
                            </motion.div>
                        </motion.div>
                    </Grid>


                    {/* <Grid
                    item
                    xs={11}
                    md={5}
                    lg={5}
                    sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        height: { xs: "350px", sm: "700px", md: "auto" },
                        minHeight: { md: "500px" },
                        borderRadius: "16px",
                        overflow: "hidden",
                        margin: "0px 15px",
                        paddingTop: "30px",
                    }}
                >
                    <MotionImage
                        src={Ras_Pros}
                        alt="raspros"
                        initial={{ opacity: 0, x: 100, scale: 0.95 }}
                        animate={{ opacity: 1, x: 0, scale: 1 }}
                        transition={{ duration: 1.1, ease: "easeOut" }}
                        style={{
                            position: "absolute",
                            right: "-70%",
                            width: "150%",
                            height: "auto",
                            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.5)",
                            padding: "10px",
                            borderRadius: "18px",
                        }}
                    />
                    <MotionImage
                        src={Ras_Pros_Mobile}
                        alt="raspros mobile"
                        initial={{ opacity: 0, scale: 0.9, y: 50 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 1.1, ease: "easeOut" }}
                        style={{
                            position: "absolute",
                            top: "18%",
                            left: 0,
                            transform: "translate(2%, 50%)",
                            width: "37%",
                            height: "auto",
                            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.5)",
                            padding: "10px",
                            marginLeft: 5,
                            borderRadius: "16px",
                            background:
                                "linear-gradient(145deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02))",
                            backdropFilter: "blur(12px)",
                            border: "1px solid rgba(255,255,255,0.1)",
                        }}
                    />
                </Grid>

                <Grid
                    item
                    md={6}
                    sm={12}
                    xs={12}
                    mb={3}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignContent: "center",
                        padding: "15px",
                        minHeight: "400px",
                        marginY: { xs: 3, md: 6 },
                    }}
                >
                    <motion.div variants={containerVariants} initial="hidden" animate="visible">
                        <Card
                            sx={{
                                maxWidth: { xs: "100vw", md: "50vw" },
                                marginX: "10px",
                                background:
                                    "linear-gradient(145deg, rgba(17,34,64,0.9), rgba(10,20,40,0.95))",
                                // boxShadow: "0 8px 24px rgba(0,0,0,0.6)",
                                borderRadius: "20px",
                                overflow: "hidden",
                                backdropFilter: "blur(10px)",
                            }}
                        >
                            <CardContent>
                                <motion.div variants={childFadeSlideUp}>
                                    <Box
                                        sx={{
                                            borderTop: "4px solid #7C3AED",
                                            borderRadius: "12px 12px 0 0",
                                            paddingTop: "10px",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: { xs: 28, sm: 42 },
                                                fontWeight: 700,
                                                color: "#E0E7FF",
                                                marginBottom: "10px",
                                                paddingX: "20px",
                                                textAlign: "left",
                                            }}
                                        >
                                            {t("main.banner.titleFirst")}
                                        </Typography>
                                    </Box>
                                </motion.div>

                                <motion.div variants={childFadeSlideUp}>
                                    <Typography
                                        sx={{
                                            fontSize: 18,
                                            color: "#A1A1AA",
                                            paddingX: "20px",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {t("main.banner.descriptionFirst")}
                                    </Typography>
                                </motion.div>
                            </CardContent>
                        </Card>

                        <motion.div variants={childFadeSlideUp}>
                            <Link to={`/${i18n.language}/signup`}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        background: "linear-gradient(135deg, #3b0764, #9333ea)",
                                        color: "#FFFFFF",
                                        border: "none",
                                        borderRadius: "12px",
                                        maxWidth: { xs: "100vw", md: "50vw" },
                                        width: "100%",
                                        margin: "20px auto",
                                        paddingY: "14px",
                                        fontSize: "1.1rem",
                                        fontWeight: 600,
                                        textTransform: "capitalize",
                                        boxShadow: "0 0 20px rgba(147, 51, 234, 0.5)",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            background: "linear-gradient(135deg, #581c87, #a855f7)",
                                            boxShadow: "0 0 26px rgba(147, 51, 234, 0.7)",
                                        },
                                    }}
                                >
                                    {t("main.banner.signUp")}
                                </Button>
                            </Link>
                        </motion.div>
                    </motion.div>
                </Grid> */}



                    <Grid
                        container
                        // spacing={4}
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            m: 4,
                            my: 5,
                            borderRadius: "10px",
                            backgroundColor: "#112240",
                            backdropFilter: 'blur(6px)',
                            p: { xs: 4, md: 6 },
                        }}
                    >
                        {/* Left Image - appears LAST on mobile */}
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', md: 'right' },
                                order: { xs: 3, md: 1 }, // 👈 mobile last, desktop first
                            }}
                        >
                            <motion.img
                                src={leftImage}
                                alt="Left Visual"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    borderRadius: 12,
                                }}
                            />
                        </Grid>

                        {/* Center Text - always in the middle */}
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                order: { xs: 2, md: 2 },
                            }}
                        >
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <Typography
                                    align="center"
                                    fontSize={{ xs: 18, sm: 24 }}
                                    sx={{
                                        fontWeight: 'bold',
                                        color: "#CFD8DC",
                                    }}
                                >
                                    {t('main.banner.neighbor1')}
                                </Typography>
                            </motion.div>
                        </Grid>

                        {/* Right Image - appears FIRST on mobile */}
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', md: 'left' },
                                order: { xs: 1, md: 3 }, // 👈 mobile first, desktop last
                            }}
                        >
                            <motion.img
                                src={rightImage}
                                alt="Right Visual"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    borderRadius: 12,
                                }}
                            />
                        </Grid>
                    </Grid>


                    {/* First Content Section */}
                    <Grid container spacing={0} alignItems="center" justifyContent="center"
                        sx={{
                            px: 2,
                            py: 6,
                            background: "#F9FAFB",
                            borderRadius: "20px",
                            margin: { xs: 1, md: 8 },
                            // paddingRight: { xs: 1.5, md: 8 }
                        }}
                    >
                        {/* Image on the Left */}
                        <Grid item xs={12} md={6}>
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginBottom: "2rem",
                                        alignItems: 'center',
                                        width: "100%",
                                        maxWidth: { xs: "100%", sm: "80%", md: "550px" },
                                        mx: "auto", // Center horizontally
                                    }}
                                >
                                    <motion.img
                                        src={RobotImage}
                                        alt="Robot Illustration"
                                        whileHover={{ scale: 1.05 }}
                                        transition={{ duration: 0.3 }}
                                        style={{
                                            width: "80%",
                                            height: "auto",
                                            borderRadius: "15px",
                                        }}
                                    />
                                </Box>
                            </motion.div>
                        </Grid>

                        {/* Text on the Right */}
                        <Grid item xs={12} md={6} pl={0}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    px: { xs: 2, md: 4 },
                                    py: { xs: 2, md: 0 },
                                }}
                            >
                                <motion.div
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 1, ease: "easeOut" }}
                                >
                                    <Typography
                                        fontSize={{ xs: 26, sm: 42 }}
                                        fontWeight="700"
                                        variant="h5"
                                        sx={{
                                            color: '#32325d',
                                            width: { xs: "100%", md: "90%" },
                                            height: "auto",
                                            marginBottom: '12px',
                                            marginTop: { xs: "none", sm: "30px" },
                                            transition: "color 0.3s ease",
                                            '&:hover': { color: '#FF7600' },
                                        }}
                                    >
                                        {/* {t('main.banner.descriptionSecond')} */}
                                        {t('main.banner.titleSecond')}
                                    </Typography>
                                    <Typography
                                        // fontSize={{ xs: 26, sm: 32 }}
                                        fontWeight="700"
                                        // variant="h5"
                                        sx={{
                                            color: '#32325d',
                                            width: { xs: "100%", md: "90%" },
                                            height: "auto",
                                            marginBottom: '12px',
                                            marginTop: { xs: "none", sm: "30px" },
                                            transition: "color 0.3s ease",
                                            '&:hover': { color: '#FF7600' },
                                        }}
                                    >
                                        {t('main.banner.descriptionSecond')}
                                    </Typography>
                                </motion.div>
                            </Box>
                        </Grid>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                // extra top spacing for breathing room
                                mt: { xs: 4, sm: 5, md: 8 },
                                mb: { xs: 2, sm: 3 },
                                px: { xs: 2, md: 0 },
                            }}
                        >
                            {/* <MotionTypography
                                // entrance animation
                                initial={{ y: 18, opacity: 0, scale: 0.98 }}
                                animate={{ y: 0, opacity: 1, scale: 1 }}
                                transition={{ duration: 0.7, ease: 'easeOut' }}

                                // small hover interaction
                                whileHover={{ scale: 1.02 }}
                                // accessibility role/level (keeps semantic h5)
                                // component="h2"
                                variant="h5"

                                sx={{
                                    // typography and centering
                                    fontSize: { xs: 26, sm: 38 },
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    mx: 'auto',
                                    width: { xs: '100%', md: '90%' },

                                    // modern gradient text
                                    background: 'linear-gradient(135deg, #3b0764, #9333ea)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    // subtle lift and glow
                                    filter: 'drop-shadow(0 6px 18px rgba(11,110,220,0.10))',
                                    letterSpacing: '-0.01em',
                                    lineHeight: 1.05,
                                    transition: 'transform 200ms ease, filter 200ms ease, color 200ms ease',

                                    // hover fallback: keep it readable on hover (you can swap behavior)
                                    '&:hover': {
                                        filter: 'drop-shadow(0 10px 30px rgba(11,110,220,0.14))',
                                    },

                                    // decorative thin underline that fades in
                                    position: 'relative',
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        bottom: -10,
                                        width: { xs: '48px', sm: '64px' },
                                        height: '4px',
                                        borderRadius: '999px',
                                        background: 'linear-gradient(90deg, rgba(11,110,220,0.9), rgba(255,118,0,0.9))',
                                        opacity: 0.85,
                                        boxShadow: '0 6px 18px rgba(11,110,220,0.08)',
                                    },
                                }}
                            >
                                Rastcom provides you with tools to succeed
                            </MotionTypography> */}
                            <SeamlessTools />
                        </Box>

                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                marginTop: 2,
                                justifyContent: 'center',
                                '& > *': {
                                    width: '100%',
                                    maxWidth: 'none',
                                },
                            }}
                        >
                            <Ai />
                        </Box>
                        <CommercialInsuranceFeature />
                    </Grid>

                </Grid >
                {/* <Ai /> */}
                {/* <CoinComponent /> */}
                <ForBusiness />
                < Elo />
                < ComparisonHome />
                {/* <RascoinHome /> */}
                <WhyWe />
                <PaymentMethods />
                <LatestBlogs />
            </Box>
        </>
    )
}